export default "__VITE_ASSET__BYBBQuLd__"